'use client'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useLocalStorageState } from 'ahooks'
import { useState, useEffect } from 'react'
import { statApi } from '@/api'
import { Cruz } from '@cruz-com/lookup'

export function useTrackingView(d: Cruz.Tracking.View, defaultValue: number = 0) {
  const [viewCount, setViewCount] = useState<number>(defaultValue)
  const [viewed, setViewed] = useLocalStorageState(`${d?.name}-${d?.id}`)

  useEffect(() => {
    if (d?.id) {
      if (viewed && dayjs(viewed as string).isAfter(dayjs().subtract(1, 'hours'))) {
        return
      }
      saveTrackingView()
    }
  }, [])

  // call api
  async function saveTrackingView() {
    try {
      const { data } = await statApi.trackingView(d)
      setViewCount(data || 0)
      if (data) {
        dayjs.extend(utc)
        setViewed(dayjs.utc().toISOString())
      }
    } catch {
    }
  }
  return { viewCount }
}
